import * as Yup from "yup"
import { AcademicLevel, Campus, Email, FirstName, LastName, MobilePhoneRequired, Consentement } from "services/validation"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
  })
})

export default schema
